// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QgL5Ppjy73s1BsHbR6kA{text-align:right !important}.FzfPVcwJHvVPuYmP13HY{text-align:left !important}`, "",{"version":3,"sources":["webpack://./Scripts/app/components/pesquisa-produtos/grid-itens/Headers/HeadersPesquisaProdutos.module.scss"],"names":[],"mappings":"AAAA,sBACE,2BAAA,CAGF,sBACE,0BAAA","sourcesContent":[".colunaAlinhadaDireita {\r\n  text-align: right !important;\r\n}\r\n\r\n.colunaAlinhadaEsquerda {\r\n  text-align: left !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colunaAlinhadaDireita": `QgL5Ppjy73s1BsHbR6kA`,
	"colunaAlinhadaEsquerda": `FzfPVcwJHvVPuYmP13HY`
};
export default ___CSS_LOADER_EXPORT___;
